import React from "react";
import AdminSidebar from "../../../components/AdminSidebar";
import GreenStockList from "../Devices/GreenStockList";
const GreenStockReport = () => {
  return (
    <AdminSidebar>
      <GreenStockList />
    </AdminSidebar>
  );
};

export default GreenStockReport;
